import { render, staticRenderFns } from "./CadastrarCampanha.vue?vue&type=template&id=483c43e2&"
import script from "./CadastrarCampanha.vue?vue&type=script&lang=js&"
export * from "./CadastrarCampanha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports